import React from "react";
import { Link } from "react-router-dom";
import "../../styles/generals/header.css";
import logo from "../../images/logo.png";

function LoginHeader({ name }) {
  return (
    <header className="px-4 pt-4">    
      <div className="d-md-flex justify-content-between">
        <p className="fs-4 my-0 text-primary fw-semibold">HELLO {(name ?? "").toUpperCase()}</p>
        <div className="logo">
            <Link to="/">
              <img src={logo} className="logo" alt="logo" />
            </Link>
        </div>
      </div>
      </header>

  );
}

export default LoginHeader;
